import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PageOption } from "../../../models/common/pageOption";
import { PaginatedList } from "../../../models/common/paginatedList";
import { Trip } from "../../../models/trips/trip";
import { TripFilter } from "../../../models/trips/tripFilter";
import { TripService } from "../../../services/trip.service";

interface IZtsiTripPickerDialogComponentData {
  clientId: number;
}

@Component({
  selector: "ztsi-trip-picker-dialog",
  templateUrl: "./ztsi-trip-picker-dialog.component.html",
  styleUrls: ["./ztsi-trip-picker-dialog.component.css"],
})
export class ZtsiTripPickerDialogComponent implements OnInit {
  searchResult: PaginatedList<Trip> | undefined = undefined;
  filter: PageOption<TripFilter> = new PageOption();
  isLoading: boolean = false;

  constructor(
    private _tripService: TripService,
    private _dialog: MatDialogRef<ZtsiTripPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IZtsiTripPickerDialogComponentData
  ) {
    this.filter.pageNumber = 1;
    this.filter.pageSize = 30;
    this.filter.orderBy = 1;
    this.filter.searchFilter = new TripFilter();
  }

  ngOnInit() {
    this.search();
  }

  search(page?: number) {
    this.isLoading = true;

    this.filter.pageNumber = page ? page : 1;
    this.filter.searchFilter.clientId = this.data.clientId;

    this._tripService.searchLimited(this.filter).subscribe((result) => {
      this.searchResult = result;
      this.isLoading = false;
    });
  }

  onSelect(trip: Trip) {
    this._dialog.close(trip);
  }

  onClose() {
    this._dialog.close(undefined);
  }

  goToPage(page: number) {
    if (page > this.searchResult.totalPages || page < 1) {
      return;
    }

    this.search(page);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-trip-picker/ztsi-trip-picker-dialog.component.ts